import { Layout } from 'antd';
import styled, { css } from 'styled-components';

const { Sider } = Layout;

export const appSiderWidthStyle = css`
  width: 200px;
`;

export const StyledSider = styled(Sider)`
  ${appSiderWidthStyle}
  background: inherit;
`;
